const offerDoc = [
    {
        id : 'OF001',
        status : 'Offered',
        guest : 'Mr Guest',
        email : 'email@example.com',
        contact : '08123456789',
        pax : 3,
        duration : 3,
        arrival : '01-01-2025',
        departure : '03-01-2025',
        price : 'Rp. 500.000',
    },
    {
        id : 'OF002',
        status : 'Offered',
        guest : 'Mr Guest',
        email : 'email@example.com',
        contact : '08123456789',
        pax : 3,
        duration : 3,
        arrival : '01-01-2025',
        departure : '03-01-2025',
        price : 'Rp. 500.000',
    },
    {
        id : 'OF003',
        status : 'Offered',
        guest : 'Mr Guest',
        email : 'email@example.com',
        contact : '08123456789',
        pax : 3,
        duration : 3,
        arrival : '01-01-2025',
        departure : '03-01-2025',
        price : 'Rp. 500.000',
    },
    {
        id : 'OF004',
        status : 'Accepted',
        guest : 'Mr Guest',
        email : 'email@example.com',
        contact : '08123456789',
        pax : 3,
        duration : 3,
        arrival : '01-01-2025',
        departure : '03-01-2025',
        price : 'Rp. 500.000',
    },
    {
        id : 'OF005',
        status : 'Accepted',
        guest : 'Mr Guest',
        email : 'email@example.com',
        contact : '08123456789',
        pax : 3,
        duration : 3,
        arrival : '01-01-2025',
        departure : '03-01-2025',
        price : 'Rp. 500.000',
    }
]

export default offerDoc